import React from 'react'

const DriverPrivacyPolicy = () => {
    return (
        <div>DriverPrivacyPolicy</div>
    )
}

export default DriverPrivacyPolicy